var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://legendao.io","target":"_"}},[_c('v-img',{attrs:{"src":require("@/assets/images/logo.svg"),"contain":"","height":"50"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }